/* istanbul ignore file */
import { Routes } from 'react-router-dom';
import { ProtectedRouter } from 'infrastructure/routing';
import { Route, Router } from 'framework/routing';
import { Page404 } from 'framework/statusPages';
import useAuthenticationService from 'infrastructure/security/authentication/authenticationService';
import TimeTrackChangeRequestReview from './TimeTrackChangeRequestReview';

const TIME_TRACKING_PATH = '/time-tracking';

const TimeTrackRouter: Router = () => {
  const { isAuthenticated } = useAuthenticationService();
  return (
    <ProtectedRouter basePath={TIME_TRACKING_PATH}>
      <Routes>
        <Route path="change-request/:id" element={<TimeTrackChangeRequestReview />} />
        <Route path="*" element={<Page404 isAuthenticated={isAuthenticated} />} />
      </Routes>
    </ProtectedRouter>
  );
};

TimeTrackRouter.getRouterPath = () => `${TIME_TRACKING_PATH}/*`;

export default TimeTrackRouter;
